import Masked from './Masked';

interface SupplierNameProps {
  /**
   * The supplier/company name, e.g. `complaint.company.name`.
   *
   * NOT the ombudsman brand name (`components/CompanyName`) — that is not
   * PII and must never be routed through this component.
   */
  value?: string | null;
}

/**
 * Masked supplier (company) name value (Medallia DXA PII masking, CD-8245).
 *
 * "Company" here means the **supplier** the complaint is against
 * (`complaint.company.name`) — not the ombudsman brand rendered by
 * `components/CompanyName`, which is not PII and stays unmasked.
 */
export function SupplierName({ value }: SupplierNameProps) {
  return <Masked>{value}</Masked>;
}

export default SupplierName;
